import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import GetUserInfoQuery from '../../../Query/User/UserInfo';
import NotLogged from './components/NotLogged';
import Logged from './components/Logged';

interface IAccountProps extends RouteComponentProps<{}> {
}

interface IAccountState {
  isOpened: boolean;
}

class Account extends React.Component<IAccountProps, IAccountState> {

  private node: any;

  constructor(props: IAccountProps) {
    super(props);

    this.state = {
      isOpened: false,
    };

    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.toggleOpened = this.toggleOpened.bind(this);
  }

  public componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  public handleOutsideClick(e: any) {
    if (this.state.isOpened) {
      if (this.node) {
        if (!this.node.contains(e.target)) {
          this.toggleOpened(false);
        }
      }
    }
  }

  public render() {
    return (
      <div
        ref={node => {
          this.node = node;
        }}
        className="header__userActions"
      >
        <GetUserInfoQuery>
          {({ userInfo }: any) => {
            if (userInfo && !!userInfo.userInfo) {
              return (
                <Logged
                  isOpened={this.state.isOpened}
                  toggleOpen={this.toggleOpened}
                  refetch={userInfo.refetch}
                />
              );
            }

            return (
              <NotLogged
                type={'icon'}
                isOpened={this.state.isOpened}
                toggleOpen={this.toggleOpened}
                refetch={userInfo.refetch}
              />
            );
          }}
        </GetUserInfoQuery>
      </div>
    );
  }

  private toggleOpened(newOpened: boolean | null = null) {
    this.setState({
      isOpened: (newOpened === null ? !this.state.isOpened : newOpened),
    });
  }
}

export default withRouter(Account);


// WEBPACK FOOTER //
// ./src/components/Header/components/Account/Account.tsx